/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
import React from 'react';

import IllustratedMessage from '@react/react-spectrum/IllustratedMessage/js/IllustratedMessage';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
    errorNoResultsFound: {
        id: 'error.noResultsFound',
        defaultMessage: 'No results found.'
    }
});

const EmptyMessage = () => {
    const { formatMessage } = useIntl();

    return (
        <IllustratedMessage
            heading={formatMessage(messages.errorNoResultsFound)}
            illustration={
                <svg title={formatMessage(messages.errorNoResultsFound)} width="99.039" height="94.342">
                    <g fill="none" stroke="#b3b3b3" strokeLinecap="round" strokeLinejoin="round">
                        <path
                            d="M93.113 88.415a5.38 5.38 0 0 1-7.61 0L58.862 61.773a1.018 1.018 0 0 1 0-1.44l6.17-6.169a1.018 1.018 0 0 1 1.439 0l26.643 26.643a5.38 5.38 0 0 1 0 7.608z"
                            strokeWidth="2.99955"
                        ></path>
                        <path
                            strokeWidth="2"
                            d="M59.969 59.838l-3.246-3.246M61.381 51.934l3.246 3.246M64.609 61.619l13.327 13.327"
                        ></path>
                        <path
                            d="M13.311 47.447A28.87 28.87 0 1 0 36.589 1.5c-10.318 0-20.141 5.083-24.7 13.46M2.121 38.734l15.536-15.536M17.657 38.734L2.121 23.198"
                            strokeWidth="3"
                        ></path>
                    </g>
                </svg>
            }
        />
    );
};

export default EmptyMessage;
